var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompaniesDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 56",
    style: {
      enableBackground: "new 0 0 50 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B4CCDD;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "33.4,18.5 33.3,17 30.7,17 30.6,18.5 30.4,28.8 30.4,28.8 30.3,30.3 33.7,30.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "28.4,30.7 28.4,26.9 21.6,30.7 21.6,26.9 14.8,30.7 14.8,39 19.2,39 19.7,39 22.1,39 22.1,39 28.4,39  28.4,39 30.3,39 31.1,39 35.2,39 35.2,26.9  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompaniesDefault);
export default __webpack_public_path__ + "static/media/companies-default.e55977d7e1d1f63a8e48e55988daba72.svg";
export { ForwardRef as ReactComponent };